import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

const existing = localStorage.getItem("wa_token");
if (existing) api.defaults.headers.common["Authorization"] = `Bearer ${existing}`;

export function setToken(token) {
  if (token) {
    localStorage.setItem("wa_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("wa_token");
    delete api.defaults.headers.common["Authorization"];
  }
}

export function authToken() {
  return localStorage.getItem("wa_token") || "";
}

export default api;
